import { useEffect, useState } from "react";
import axiosClient from "../services/axiosClient";
import { Toast } from "../components";

const useFetchData = (path, params = {}, error = "") => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [status, setStatus] = useState(200);
  useEffect(() => {
    setLoading(true);
    async function getData() {
      try {
        const { isRefresh, ...rest } = params
        const res = await axiosClient.get(path, {
          params: {
            ...rest,
          },
        });
        if (res) {
          setData(res)
        }
        setLoading(false);
        if (res.count && params.size && pages) {
          setPages(Math.ceil(res.count / params.size));
        }
      } catch (e) {
        setLoading(false)
        if (e.response.status === 403 && count < 1 && error) {
          Toast.open(`Bạn không có quyền ${error}`, "danger")
          setCount(count + 1)
          setStatus(e.response?.status)
        }
      }
    }
    getData();
    // eslint-disable-next-line
  }, [
    path,
    params?.page,
    params?.isRefresh,
    params?.subject_name_group_camera,
    params?.camera_name,
    params?.day_start,
    params?.day_end,
    params?.device,
    params?.province_name,
    params?.district_name,
    params?.commune_name,
    params?.user_type_name
  ]);
  return { data, loading, pages, status };
};
export default useFetchData;
